var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal-card", staticStyle: { width: "auto" } },
    [
      _c(
        "div",
        { staticClass: "modal-card-body" },
        [
          _c("b-loading", {
            attrs: { active: _vm.loading, "is-full-page": "" },
            on: {
              "update:active": function ($event) {
                _vm.loading = $event
              },
            },
          }),
          _c("span", { staticClass: "buttons" }, [
            _c(
              "button",
              {
                staticClass: "button is-warning is-outlined is-small",
                on: { click: _vm.close },
              },
              [
                _c("b-icon", { attrs: { icon: "chevron-left" } }),
                _c("span", [_vm._v(_vm._s(_vm.$t("global.back")))]),
              ],
              1
            ),
          ]),
          _c("ValidationObserver", {
            ref: "observer",
            attrs: { tag: "form" },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.submit.apply(null, arguments)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ formValid }) {
                  return [
                    _c(
                      "b-field",
                      {
                        attrs: {
                          label: _vm.$t(
                            "pages.pickup_management.collect_creation.comments1"
                          ),
                        },
                      },
                      [
                        _c("ValidationProvider", [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.comments1,
                                expression: "comments1",
                              },
                            ],
                            staticClass: "input",
                            domProps: { value: _vm.comments1 },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.comments1 = $event.target.value
                              },
                            },
                          }),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      {
                        attrs: {
                          label: _vm.$t(
                            "pages.pickup_management.collect_creation.comments2"
                          ),
                        },
                      },
                      [
                        _c("ValidationProvider", [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.comments2,
                                expression: "comments2",
                              },
                            ],
                            staticClass: "input",
                            domProps: { value: _vm.comments2 },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.comments2 = $event.target.value
                              },
                            },
                          }),
                        ]),
                      ],
                      1
                    ),
                    _vm.hasIndiaEnduser || _vm.hasBrazilEnduser
                      ? _c(
                          "b-field",
                          { attrs: { label: "Type" } },
                          [
                            _c("ValidationProvider", {
                              attrs: { slim: "", rules: { required: true } },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c(
                                          "b-select",
                                          {
                                            attrs: {
                                              placeholder: "Select type",
                                              expanded: "",
                                            },
                                            model: {
                                              value: _vm.selectedType,
                                              callback: function ($$v) {
                                                _vm.selectedType = $$v
                                              },
                                              expression: "selectedType",
                                            },
                                          },
                                          _vm._l(_vm.types, function (type) {
                                            return _c(
                                              "option",
                                              {
                                                key: type.value,
                                                domProps: { value: type.value },
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(type.text) + " "
                                                ),
                                              ]
                                            )
                                          }),
                                          0
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "has-text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.hasIndiaEnduser
                      ? _c(
                          "b-field",
                          { attrs: { label: "Customer" } },
                          [
                            _c("ValidationProvider", {
                              attrs: { slim: "", rules: { required: true } },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c(
                                          "b-select",
                                          {
                                            attrs: {
                                              placeholder: "Select customer",
                                              expanded: "",
                                            },
                                            model: {
                                              value: _vm.selectedCustomer,
                                              callback: function ($$v) {
                                                _vm.selectedCustomer = $$v
                                              },
                                              expression: "selectedCustomer",
                                            },
                                          },
                                          _vm._l(
                                            _vm.customers,
                                            function (customer) {
                                              return _c(
                                                "option",
                                                {
                                                  key: customer.customerId,
                                                  domProps: {
                                                    value: customer.customerId,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        customer.customerId +
                                                          " - " +
                                                          customer.customerName
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "has-text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.endusersData && _vm.endusersData.length > 0
                      ? _c(
                          "div",
                          { staticClass: "d-row" },
                          _vm._l(_vm.endusersData, function (enduser, usernum) {
                            return _c(
                              "div",
                              {
                                key: enduser.enduserCode,
                                staticClass: "container-card card",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "card-header centered-items" },
                                  [
                                    _c("h2", { staticClass: "subtitle m" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(enduser.enduserCode) +
                                          " - " +
                                          _vm._s(enduser.enduserName) +
                                          " "
                                      ),
                                    ]),
                                    enduser.theoricalStock ||
                                    enduser.theoricalStock === 0
                                      ? _c(
                                          "span",
                                          { staticClass: "has-text-primary" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "pages.pickup_management.collect_creation.theorical_stock"
                                                )
                                              ) +
                                                " : " +
                                                _vm._s(enduser.theoricalStock)
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "span",
                                      { staticClass: "has-text-warning" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "pages.pickup_management.collect_creation.weight"
                                            )
                                          ) +
                                            " : " +
                                            _vm._s(_vm.calcWeight(enduser)) +
                                            " KG"
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "container card-content" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex-column" },
                                      [
                                        _c(
                                          "b-field",
                                          {
                                            attrs: {
                                              id: "calendar-step-cc-load-date",
                                              label: _vm.$t(
                                                "pages.pickup_management.calendar.infos.notification_date"
                                              ),
                                            },
                                          },
                                          [
                                            _c("ValidationProvider", {
                                              attrs: {
                                                rules: "required",
                                                name: "date",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c("b-datepicker", {
                                                          attrs: {
                                                            name: "date",
                                                            icon: "calendar-alt",
                                                            placeholder: _vm.$t(
                                                              "global.click_to_select"
                                                            ),
                                                            "date-formatter": (
                                                              date
                                                            ) =>
                                                              _vm
                                                                .$dayjs(date)
                                                                .format(
                                                                  "DD/MM/YYYY"
                                                                ),
                                                          },
                                                          model: {
                                                            value:
                                                              enduser.loadingDate,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                enduser,
                                                                "loadingDate",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "enduser.loadingDate",
                                                          },
                                                        }),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "has-text-danger",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(errors[0])
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                        enduser.lastInventory &&
                                        enduser.lastInventory.length > 0
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "card has-text-centered content-card",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "card-header",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "card-header-title",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "pages.pickup_management.collect_creation.last_inventory"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "card-content",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "subtitle",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm
                                                                .$dayjs(
                                                                  enduser
                                                                    .lastDeclaration
                                                                    .date
                                                                )
                                                                .format(
                                                                  "DD-MM-YYYY"
                                                                )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c("div", {
                                                      staticClass: "separator",
                                                    }),
                                                    _vm._l(
                                                      enduser.lastInventory,
                                                      function (row, index) {
                                                        return _c(
                                                          "div",
                                                          { key: index },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    row.material
                                                                  ) +
                                                                  " : "
                                                              ),
                                                            ]),
                                                            _c("span", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    row.quantity
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    _c("div", {
                                                      staticClass: "separator",
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "subtitle",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "pages.pickup_management.collect_creation.comments"
                                                            )
                                                          ) + " :"
                                                        ),
                                                      ]
                                                    ),
                                                    _c("div", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            enduser
                                                              .lastDeclaration
                                                              .comments
                                                          ) +
                                                          " "
                                                      ),
                                                    ]),
                                                  ],
                                                  2
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        enduser.filteredClosures &&
                                        enduser.filteredClosures.length > 0
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "card has-text-centered content-card",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "card-header",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "card-header-title",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "pages.pickup_management.collect_creation.closures"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "card-content",
                                                  },
                                                  _vm._l(
                                                    enduser.filteredClosures,
                                                    function (c) {
                                                      return _c(
                                                        "div",
                                                        { key: c.id },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm
                                                                  .$dayjs(
                                                                    c.startDate
                                                                  )
                                                                  .format(
                                                                    "DD/MM/YYYY"
                                                                  )
                                                              ) +
                                                              " "
                                                          ),
                                                          _c("b-icon", {
                                                            staticClass:
                                                              "is-small",
                                                            attrs: {
                                                              icon: "arrow-right",
                                                            },
                                                          }),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm
                                                                  .$dayjs(
                                                                    c.endDate
                                                                  )
                                                                  .format(
                                                                    "DD/MM/YYYY"
                                                                  )
                                                              ) +
                                                              " "
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "flex-row" },
                                      [
                                        _vm._l(
                                          enduser.mats,
                                          function (mat, index) {
                                            return _c(
                                              "div",
                                              {
                                                key: index,
                                                attrs: { id: "matsDisplay" },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "m" },
                                                  [
                                                    _vm._v("Mat : "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "has-text-primary subtitle",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(mat.mat.MATNR)
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  { staticClass: "m" },
                                                  [_vm._v("|")]
                                                ),
                                                _c(
                                                  "span",
                                                  { staticClass: "m" },
                                                  [
                                                    _vm._v("Quantity : "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "has-text-primary subtitle",
                                                      },
                                                      [_vm._v(_vm._s(mat.qty))]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  [
                                                    _c("b-button", {
                                                      attrs: {
                                                        "icon-left": "trash",
                                                        size: "is-small",
                                                      },
                                                      on: {
                                                        click: () => {
                                                          enduser.mats.splice(
                                                            index,
                                                            1
                                                          )
                                                          _vm.$forceUpdate()
                                                        },
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        _c("div", { staticClass: "form" }, [
                                          enduser
                                            ? _c(
                                                "div",
                                                [
                                                  enduser.newMat
                                                    ? _c(
                                                        "b-field",
                                                        {
                                                          attrs: {
                                                            label:
                                                              "Adding material",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "container",
                                                            },
                                                            [
                                                              _c(
                                                                "ValidationProvider",
                                                                {
                                                                  staticClass:
                                                                    "m-r",
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "default",
                                                                          fn: function ({
                                                                            errors,
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "span",
                                                                                [
                                                                                  enduser &&
                                                                                  enduser.materials
                                                                                    ? _c(
                                                                                        "multiselect",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              id: "calendar-step-cc-material-choose",
                                                                                              options:
                                                                                                enduser.materials,
                                                                                              multiple: false,
                                                                                              "close-on-select": true,
                                                                                              placeholder:
                                                                                                _vm.$t(
                                                                                                  "pages.pickup_management.collect_creation.select_material"
                                                                                                ),
                                                                                              label:
                                                                                                "MATNR",
                                                                                              "track-by":
                                                                                                "MATNR",
                                                                                            },
                                                                                          model:
                                                                                            {
                                                                                              value:
                                                                                                enduser
                                                                                                  .newMat
                                                                                                  .mat,
                                                                                              callback:
                                                                                                function (
                                                                                                  $$v
                                                                                                ) {
                                                                                                  _vm.$set(
                                                                                                    enduser.newMat,
                                                                                                    "mat",
                                                                                                    $$v
                                                                                                  )
                                                                                                },
                                                                                              expression:
                                                                                                "enduser.newMat.mat",
                                                                                            },
                                                                                        }
                                                                                      )
                                                                                    : _vm._e(),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                }
                                                              ),
                                                              _c(
                                                                "ValidationProvider",
                                                                {
                                                                  staticClass:
                                                                    "m-r",
                                                                  attrs: {
                                                                    rules: {
                                                                      required: true,
                                                                      dynamic_max_value:
                                                                        {
                                                                          enduser:
                                                                            enduser,
                                                                          selectMat:
                                                                            enduser
                                                                              .newMat
                                                                              .mat,
                                                                        },
                                                                    },
                                                                    name: "quantity",
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "default",
                                                                          fn: function ({
                                                                            errors,
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "span",
                                                                                [
                                                                                  _c(
                                                                                    "b-input",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          id: "calendar-step-cc-qty",
                                                                                          type: "text",
                                                                                          pattern:
                                                                                            "[a-zA-Z0-9 ]+",
                                                                                          name: "quantity",
                                                                                        },
                                                                                      model:
                                                                                        {
                                                                                          value:
                                                                                            enduser
                                                                                              .newMat
                                                                                              .qty,
                                                                                          callback:
                                                                                            function (
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                enduser.newMat,
                                                                                                "qty",
                                                                                                $$v
                                                                                              )
                                                                                            },
                                                                                          expression:
                                                                                            "enduser.newMat.qty",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "container has-text-danger",
                                                                                  style:
                                                                                    {
                                                                                      maxWidth:
                                                                                        "200px",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      errors[0]
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                }
                                                              ),
                                                              _c(
                                                                "b-button",
                                                                {
                                                                  staticClass:
                                                                    "m-r",
                                                                  on: {
                                                                    click:
                                                                      () => {
                                                                        enduser.newMat =
                                                                          null
                                                                        _vm.$forceUpdate()
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "global.cancel"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "b-button",
                                                                {
                                                                  attrs: {
                                                                    id: "calendar-step-cc-add",
                                                                    type: "is-primary",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.submitAddMat(
                                                                          enduser
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "global.add"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                                enduser.mats.length > 0 &&
                                _vm.hasBrazilEnduser &&
                                _vm.selectedType === "DMC"
                                  ? _c(
                                      "div",
                                      { staticClass: "ml-4" },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              type: "is-primary",
                                              "icon-left": "plus",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addNota(usernum)
                                              },
                                            },
                                          },
                                          [_vm._v(" Add nota ")]
                                        ),
                                        enduser.mats.length > 0 &&
                                        _vm.notaFiscalArray[usernum].length > 0
                                          ? _c(
                                              "div",
                                              {
                                                style: {
                                                  color:
                                                    _vm.notaFiscalArray[
                                                      usernum
                                                    ].reduce(
                                                      (total, obj) =>
                                                        parseInt(obj.quantity) +
                                                        total,
                                                      0
                                                    ) !=
                                                    enduser.mats.reduce(
                                                      (total, obj) =>
                                                        parseInt(obj.qty) +
                                                        total,
                                                      0
                                                    )
                                                      ? "red"
                                                      : "black",
                                                },
                                              },
                                              _vm._l(
                                                enduser.mats,
                                                function (mat, ind) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: ind + "notareadout",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            "Assigned " +
                                                              mat.mat.MATNR +
                                                              " Stock: " +
                                                              _vm.notaFiscalArray[
                                                                usernum
                                                              ]
                                                                .filter((x) => {
                                                                  return (
                                                                    x.mat
                                                                      .MATNR ===
                                                                    mat.mat
                                                                      .MATNR
                                                                  )
                                                                })
                                                                .reduce(
                                                                  (
                                                                    total,
                                                                    obj
                                                                  ) =>
                                                                    parseInt(
                                                                      obj.quantity
                                                                    ) + total,
                                                                  0
                                                                ) +
                                                              "/" +
                                                              enduser.mats
                                                                .filter((x) => {
                                                                  return (
                                                                    x.mat
                                                                      .MATNR ===
                                                                    mat.mat
                                                                      .MATNR
                                                                  )
                                                                })
                                                                .reduce(
                                                                  (
                                                                    total,
                                                                    obj
                                                                  ) =>
                                                                    parseInt(
                                                                      obj.qty
                                                                    ) + total,
                                                                  0
                                                                )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _vm._e(),
                                        _vm._l(
                                          _vm.notaFiscalArray[usernum],
                                          function (nota, numNota) {
                                            return _c(
                                              "b-field",
                                              {
                                                key: numNota + "Nota",
                                                attrs: { grouped: "" },
                                              },
                                              [
                                                _c(
                                                  "b-field",
                                                  {
                                                    attrs: {
                                                      label: "Nota Fiscal",
                                                    },
                                                  },
                                                  [
                                                    _c("b-input", {
                                                      attrs: { type: "text" },
                                                      model: {
                                                        value: nota.id,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            nota,
                                                            "id",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "nota.id",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "b-field",
                                                  {
                                                    attrs: {
                                                      label: "Quantity",
                                                    },
                                                  },
                                                  [
                                                    _c("b-input", {
                                                      attrs: {
                                                        type: "number",
                                                        min: "0",
                                                      },
                                                      model: {
                                                        value: nota.quantity,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            nota,
                                                            "quantity",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "nota.quantity",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "b-field",
                                                  {
                                                    attrs: {
                                                      label: "Material",
                                                    },
                                                  },
                                                  [
                                                    enduser && enduser.materials
                                                      ? _c("multiselect", {
                                                          attrs: {
                                                            id: "calendar-step-cc-material-choose",
                                                            options:
                                                              enduser.materials,
                                                            multiple: false,
                                                            "close-on-select": true,
                                                            placeholder: _vm.$t(
                                                              "pages.pickup_management.collect_creation.select_material"
                                                            ),
                                                            label: "MATNR",
                                                            "track-by": "MATNR",
                                                          },
                                                          model: {
                                                            value: nota.mat,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                nota,
                                                                "mat",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "nota.mat",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "b-field",
                                                  { attrs: { label: " " } },
                                                  [
                                                    _c("b-button", {
                                                      staticClass:
                                                        "left-right mr-2",
                                                      attrs: {
                                                        type: "is-ghost",
                                                        "icon-left": "x",
                                                      },
                                                      on: {
                                                        click: () => {
                                                          _vm.removeNota(
                                                            usernum,
                                                            numNota
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                enduser.mats.length < 5
                                  ? _c(
                                      "div",
                                      { staticClass: "center" },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              id: "calendar-step-cc-materials",
                                              type: "is-info",
                                              "icon-left": "plus",
                                              disabled: enduser.newMat,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addMat(enduser)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "pages.pickup_management.collect_creation.add_material"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _c("div", { staticClass: "submit-section" }, [
                      _c(
                        "button",
                        {
                          staticClass: "is-primary button",
                          attrs: {
                            id: "calendar-step-cc-submit",
                            type: "submit",
                            disabled: _vm.endusersData.find((d) => d.newMat),
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }